// @flow
import React from 'react';
import { useForm } from 'react-hook-form';

type VerticalFromProps = {
    defaultValues?: Array,
    resolver?: any,
    children?: any,
    onSubmit?: (value: any) => void,
    formClass?: string,
};

const VerticalForm = ({
    defaultValues,
    resolver,
    children,
    onSubmit,
    formClass,
}: VerticalFromProps): React$Element<any> => {
    /*
     * form methods
     */
    const methods = useForm({ defaultValues, resolver });
    const {
        handleSubmit,
        register,
        control,
        formState: { errors },
    } = methods;

    const renderChildren = (children) => {
        return React.Children.map(children, (child) => {
            if (!React.isValidElement(child)) {
                return child;
            }

            if (child.props && child.props.name) {
                return React.cloneElement(child, {
                    register,
                    errors,
                    control,
                    ...child.props,
                    key: child.props.name,
                });
            }

            if (child.props && child.props.children) {
                return React.cloneElement(child, {
                    ...child.props,
                    children: renderChildren(child.props.children),
                });
            }

            return child;
        });
    };

    return (
        <form onSubmit={handleSubmit(onSubmit)} className={formClass} noValidate>
            {renderChildren(children)}
        </form>
    );
};

export default VerticalForm;
